/* eslint-disable max-len */
// ==============================================
// ==================Import======================
// ==============================================

// ==================Style&IMG===================
import './style.scss';

// =================Material UI==================
import {
  Backdrop,
  Box,
  Fade,
  Modal,
  Typography,
} from '@mui/material';

// =================React Hook==================
import { useSelector, useDispatch } from 'react-redux';

// =================Actions==================
import { setModalNoData } from '../../actions/multipleMetadata';

function ModalNoData() {
// ==================HOOK=========================
  const dispatch = useDispatch();
  const openCommandLineClientModal = useSelector(
    (state) => state.multipleMetadata.modalNoData,
  );
  // ==================handler=========================
  const handleCloseCommandLineClientModal = () => {
    dispatch(setModalNoData(false));
  };

  const handleCloseCommandLineClientModalWindow = () => {
    window.close();
  };

  return (
    <Modal
      open={openCommandLineClientModal}
      onClose={handleCloseCommandLineClientModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 600,
        },
      }}
    >
      <Fade in={openCommandLineClientModal}>
        <Box className="commandLineClient--modal">
          <Typography id="modal-modal-title" variant="h4" component="h2">
            No data available
          </Typography>
          <Box className="commandLineClient--modal__text">
            <p>
              No data available for this selection please modify your query or get a new request
            </p>
            <div className="commandLineClient--modal__text--button">
              {/* <button className="commandLineClient--modal__text--button__close" type="button" onClick={handleCloseCommandLineClientModal}>Close</button> */}
              <button className="commandLineClient--modal__text--button__close--window" type="button" onClick={handleCloseCommandLineClientModalWindow}>Close the window</button>
            </div>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}

export default ModalNoData;
